module.exports = (text, maxLength, ellipsis = "…") ->
  if text.length > maxLength
    text
    # Take one more character, so we can see if it would be a space
    .substr(0, maxLength - ellipsis.length + 1)
    # truncate and remove spaces and partial words left at the end of the strin
    .replace(/\s+\S*$/, "") + ellipsis
  else
    text



// WEBPACK FOOTER //
// ./app/scripts/lib/util/text/truncate.coffee